import { render, staticRenderFns } from "./AuthorizingPersons.vue?vue&type=template&id=094a9c10&scoped=true&"
import script from "./AuthorizingPersons.vue?vue&type=script&lang=js&"
export * from "./AuthorizingPersons.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizingPersons.vue?vue&type=style&index=0&id=094a9c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094a9c10",
  null
  
)

export default component.exports